import { Col, Form, Row } from "react-bootstrap"
import { Door, Pass, PassType, RentManagerProperty, RentManagerUnit } from "../data/models.interface"
import ItemSelect from "./ItemSelect"
import PassDoorsSubForm from "./PassDoorsSubForm"

interface IPassForm {
	pass: Pass
	setPass: (pass: Pass) => void
	touched: Map<string, boolean>
	setTouched: (value: Map<string, boolean>) => void
	validationErrors: Map<string, string>
	doors: Door[]
	properties: RentManagerProperty[]
	units: RentManagerUnit[]
}
const PassForm = ({ pass, setPass, touched, setTouched, validationErrors, doors, properties, units }: IPassForm) => {
	const setFieldTouched = (field: string) => {
		// need to make it a new object to trigger the state change
		touched = new Map(touched)
		touched.set(field, true)
		setTouched(touched)
	}
	const showPropertyField =
		pass?.type === PassType.AMENITIES || pass?.type === PassType.EXTERIOR || pass?.type === PassType.UNIT
	const showUnitField = pass?.type === PassType.UNIT
	return (
		<>
			<Row className="mt-4">
				<Col xs={12} sm={6} lg>
					<Form.Group className="mb-3" controlId="name">
						<Form.Label>Name</Form.Label>
						<Form.Control
							type="text"
							required
							value={pass.name || ""}
							onChange={(e) => setPass({ ...pass, name: e.target.value })}
							onBlur={() => setFieldTouched("name")}
							isInvalid={touched.get("name") && validationErrors.has("name")}
						/>
						<Form.Control.Feedback type="invalid">{validationErrors.get("name")}</Form.Control.Feedback>
					</Form.Group>
				</Col>
				<Col xs={12} sm={6} lg={4}>
					<Form.Group className="mb-3" controlId="access">
						<Form.Label>Type</Form.Label>
						<Form.Select
							required
							value={pass.type}
							onChange={(e) => setPass({ ...pass, type: e.target.value as PassType })}>
							<option value={PassType.AMENITIES}>{PassType.AMENITIES}</option>
							<option value={PassType.EXTERIOR}>{PassType.EXTERIOR}</option>
							<option value={PassType.ROLE}>{PassType.ROLE}</option>
							<option value={PassType.UNIT}>{PassType.UNIT}</option>
						</Form.Select>
					</Form.Group>
				</Col>
				{showPropertyField && (
					<Col xs={12} sm={6} lg={4}>
						<Form.Group className="mb-3" controlId="propertyId">
							<Form.Label>Property</Form.Label>
							<ItemSelect
								placeholder="--Select a Property--"
								required
								items={properties}
								convert={(p) => ({ id: p.PropertyID.toFixed(0), name: p.Name })}
								valueId={pass.propertyId?.toFixed(0)}
								onChange={(property?: RentManagerProperty) =>
									setPass({
										...pass,
										propertyId: property?.PropertyID,
										propertyName: property?.Name,
										propertyShortName: property?.ShortName,
									})
								}
								onBlur={() => setFieldTouched("propertyId")}
								isInvalid={touched.get("propertyId") && validationErrors.has("propertyId")}
							/>
							<Form.Control.Feedback type="invalid">{validationErrors.get("propertyId")}</Form.Control.Feedback>
						</Form.Group>
					</Col>
				)}
				{showUnitField && (
					<Col xs={12} sm={6} lg={4}>
						<Form.Group className="mb-3" controlId="unitId">
							<Form.Label>Unit</Form.Label>
							<ItemSelect
								placeholder="--Select a Unit--"
								required
								items={units}
								convert={(u) => ({ id: u.UnitID.toFixed(0), name: u.Name })}
								valueId={pass.unitId?.toFixed(0)}
								onChange={(unit?: RentManagerUnit) =>
									setPass({
										...pass,
										unitId: unit?.UnitID,
										unitName: unit?.Name,
									})
								}
								onBlur={() => setFieldTouched("unitId")}
								isInvalid={touched.get("unitId") && validationErrors.has("unitId")}
							/>
							<Form.Control.Feedback type="invalid">{validationErrors.get("unitId")}</Form.Control.Feedback>
						</Form.Group>
					</Col>
				)}
			</Row>
			<Row className="mt-4">
				<PassDoorsSubForm
					passDoors={pass.doors}
					setPassDoors={(value) => setPass({ ...pass, doors: [...value] })}
					doors={doors}
				/>
			</Row>
		</>
	)
}
export default PassForm
